module.exports = __webpack_public_path__ + "static/img/2023_9_8_6.499dd5fa.499dd5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_6.499dd5fa.jpg
// module id = meCw
// module chunks = 0